import PartnerAccountsTable from './PartnerAccountsTable';

export default PartnerAccountsTable;
